/*
 * @Author: laishaojiang
 * @Date: 2021-09-13 19:41:59
 * @Description: 订单/地址等场景手机号脱敏展示，点击眼睛后拉取明文
 */
import util from 'lib/util'

export default {
  data() {
    return {
      isShowSendPhone: false,
      isShowRecPhone: false,
      sensitivePlaintextCache: {}
    }
  },

  computed: {
    sendPhoneSensitiveOpts() {
      return this.sensitivePhoneOpts('sendmobile')
    },
    recPhoneSensitiveOpts() {
      return this.sensitivePhoneOpts('recmobile')
    }
  },

  methods: {
    getOrderDetailContext() {
      return this.orderDetail || this.detail || this.order || this.orderDetailInfo || {}
    },

    getSensitiveCacheKey(opts) {
      const { cname, type, sid } = opts || {}
      if (!cname || !type || !sid) {
        return ''
      }
      return `${type}_${sid}_${cname}`
    },

    /** 订单等场景：组装敏感字段明文查询参数 */
    sensitivePhoneOpts(cname, options = {}) {
      const { type = 'order', sid, text } = options
      const detail = this.getOrderDetailContext()
      const businessId = sid || detail.expid || detail.expId || this.expid || this.expId
      let maskedText = text
      if (maskedText == null || maskedText === '') {
        if (cname === 'sendmobile') {
          maskedText = detail.sendmobile || detail.sendMobile || detail.sendPhone || detail.sendtel || detail.sendTel || ''
        } else {
          maskedText = detail.recmobile || detail.recMobile || detail.recPhone || detail.rectel || detail.recTel || ''
        }
      }
      if (!businessId || !maskedText) {
        return null
      }
      return {
        cname,
        text: maskedText,
        type,
        sid: String(businessId)
      }
    },

    /**
     * 地址簿明文业务类型：寄件人 sendaddress，收件人 recaddress
     * tag：1/send/sendman 为寄件人，2/rec/recman 为收件人
     */
    getAddressSensitiveType(contact) {
      const tag = contact && contact.tag
      if (tag == 1 || tag === 'send' || tag === 'sendman' || tag === 'SENDER') {
        return 'sendaddress'
      }
      if (tag == 2 || tag === 'rec' || tag === 'recman' || tag === 'RECEIVER' || tag === 'ADDRESSEE') {
        return 'recaddress'
      }
      const routeTag = this.$route && (this.$route.query.tag || this.$route.params.tag)
      if (routeTag === 'send' || routeTag === 'sendman') {
        return 'sendaddress'
      }
      if (routeTag === 'rec' || routeTag === 'recman') {
        return 'recaddress'
      }
      if (this.$options.name === 'addressList' && this.type == 1) {
        return 'sendaddress'
      }
      if (this.$options.name === 'addressList' && this.type == 2) {
        return 'recaddress'
      }
      return 'address'
    },

    /** 地址簿场景 */
    addressPhoneSensitiveOpts(contact) {
      if (!contact || !contact.id) {
        return null
      }
      const useTel = !contact.phone && contact.fixedPhone
      const cname = useTel ? 'tel' : 'mobile'
      const text = useTel ? contact.fixedPhone : contact.phone
      if (!text) {
        return null
      }
      return {
        cname,
        text,
        type: this.getAddressSensitiveType(contact),
        sid: String(contact.id)
      }
    },

    async fetchSensitivePlaintext(opts) {
      const cacheKey = this.getSensitiveCacheKey(opts)
      if (!cacheKey) {
        return ''
      }
      if (this.sensitivePlaintextCache[cacheKey]) {
        return this.sensitivePlaintextCache[cacheKey]
      }
      const { cname, text, type, sid } = opts
      const res = await this.$request('/perapi-system/sensitive/plaintext', {
        contentType: 'application/json',
        data: {
          cname,
          text,
          type,
          sid
        }
      })
      const payload = res.data
      const plaintext = typeof payload === 'string' ? payload : (payload?.text ?? payload?.plaintext ?? '')
      this.$set(this.sensitivePlaintextCache, cacheKey, plaintext)
      return plaintext
    },

    async togglePhone(flagKey, sensitiveOpts) {
      const isShow = this[flagKey]
      if (!isShow && sensitiveOpts?.cname && sensitiveOpts?.sid) {
        try {
          await this.fetchSensitivePlaintext(sensitiveOpts)
        } catch (e) {
          return
        }
      }
      this[flagKey] = !isShow
    },

    /**
     * 地址编辑/选址：掩码号码换明文（编辑、下单回填）
     * 使用 /pcweb/addressbook/querybaseaddressbook 拉取明文
     */
    async resolveAddressPlainPhone(detail) {
      if (!detail || !detail.id) {
        return detail
      }
      const result = { ...detail }
      const needPhone = result.phone && String(result.phone).indexOf('*') > -1
      const needTel = result.fixedPhone && String(result.fixedPhone).indexOf('*') > -1
      const needAddress = result.address && String(result.address).indexOf('*') > -1
      if (!needPhone && !needTel && !needAddress) {
        return result
      }
      try {
        const res = await this.$http.get('/pcweb/addressbook/querybaseaddressbook', {
          data: {
            addrId: result.id
          }
        })
        const plain = (res && res.data) || {}
        if (needPhone) {
          result.phone = plain.phone || ''
        }
        if (needTel) {
          result.fixedPhone = plain.fixedPhone || ''
        }
        if (needAddress) {
          result.address = plain.address || result.address
        }
      } catch (e) {
        if (needPhone) {
          result.phone = ''
        }
        if (needTel) {
          result.fixedPhone = ''
        }
      }
      return result
    },

    /** 地址簿列表：按联系人切换手机号展示 */
    async toggleContactPhone(contact) {
      if (!contact) {
        return
      }
      const sensitiveOpts = this.addressPhoneSensitiveOpts(contact)
      if (!contact.isShowPhone && sensitiveOpts?.sid) {
        try {
          await this.fetchSensitivePlaintext(sensitiveOpts)
        } catch (e) {
          return
        }
      }
      contact.isShowPhone = !contact.isShowPhone
    },

    eyesSrc(val) {
      return val ? 'https://cdn.kuaidi100.com/images/rebuild/icon-open_lock.png' : 'https://cdn.kuaidi100.com/images/rebuild/icon-close_lock.png'
    },

    encryptionPhone(val, show, sensitiveOpts) {
      if (!val) {
        return val
      }
      if (!show) {
        if (/\*/.test(String(val))) {
          return val
        }
        return util.hidePhone(val)
      }
      const cacheKey = this.getSensitiveCacheKey(sensitiveOpts)
      if (cacheKey && this.sensitivePlaintextCache[cacheKey]) {
        return this.sensitivePlaintextCache[cacheKey]
      }
      return val
    }
  }
}
